import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7101 4.7382C11.0966 4.11132 11.5297 3.54501 12 3.04825C12.4703 3.54501 12.9034 4.11132 13.29 4.7382C14.3868 6.51678 15.0994 8.76779 15.2288 11.25H8.77129C8.90067 8.76779 9.61329 6.51678 10.7101 4.7382ZM7.26944 11.25C7.40012 8.50227 8.18432 5.97628 9.4333 3.95087C9.78837 3.37507 10.1818 2.83849 10.6096 2.34839C6.12618 2.98855 2.62619 6.67871 2.27844 11.25L7.26944 11.25ZM2.27844 12.75L7.26347 12.75C7.40163 16.2436 8.59696 19.3995 10.4741 21.6313C6.05587 20.9369 2.62268 17.2751 2.27844 12.75ZM8.7647 12.75H15.2353C15.0874 16.1718 13.8331 19.1528 12 21.0893C10.1669 19.1528 8.91263 16.1718 8.7647 12.75ZM16.7366 12.75C16.5984 16.2436 15.4031 19.3995 13.5259 21.6313C17.9442 20.9369 21.3774 17.2751 21.7216 12.75L16.7366 12.75ZM21.7216 11.25C21.3739 6.67871 17.8739 2.98855 13.3905 2.34839C13.8182 2.83849 14.2117 3.37507 14.5668 3.95087C15.8157 5.97628 16.5999 8.50227 16.7306 11.25L21.7216 11.25Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
